// Lazily load Razorpay Checkout's script — ONLY when a booking page actually
// needs to open checkout, instead of a global <script> in index.html. The
// global tag made Razorpay eagerly prefetch its chunk bundles
// (checkout-static-next.razorpay.com/.../v2-entry-loader-*.modern.js, etc.) on
// EVERY page of the app. Loading on demand keeps those off non-payment pages.
//
// Idempotent: injects the <script> at most once and resolves when
// window.Razorpay is available; concurrent callers share one promise.
let loadPromise: Promise<void> | null = null;

export function loadRazorpay(): Promise<void> {
  if ((window as any).Razorpay) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>("script[data-razorpay]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("razorpay_script_failed")));
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.dataset.razorpay = "1";
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null; // allow a retry on the next attempt
      reject(new Error("razorpay_script_failed"));
    };
    document.body.appendChild(script);
  });
  return loadPromise;
}

export default loadRazorpay;
